define([
	"csi/access/crews",
    "csi/xml",
    "csi/view",
	"./Review/RegenerateApprovedAction",
    "./Review/RegeneratePendingAction"
], function(crews,xml,csiView) {

	return {
		// OperationsReview states
		reviewStateDraft: "Draft",
		reviewStatePending: "Pending",
		reviewStateApproved: "Approved",

		// Operations Review roles
        orReviewerRoles: ["Operations Review Administrator", "Operations Review Editor"],
        orApproverRoles: ["Revision Approver"],

        PENDING_PDF_STATUS : "PendingPDF.Status",
        APPROVED_PDF_STATUS : "ApprovedPDF.Status",

		onAccessActionORToPending: function(/*Context*/ctx, /*Action*/action) {
			var state = this.getReviewState(ctx.getNode());
			return state == this.reviewStateDraft && crews.isInRoles(this.orReviewerRoles, ctx.getNode());
		},

		onAccessActionORToApproved: function(/*Context*/ctx, /*Action*/action) {
			var state = this.getReviewState(ctx.getNode());
			return state == this.reviewStatePending
				&& crews.isInRoles(this.orApproverRoles, ctx.getNode())
				&& ctx.getNode()[this.PENDING_PDF_STATUS] == undefined;
		},

		onAccessActionORDelete: function(/*Context*/ctx, /*Action*/action) {
		   var state = this.getReviewState(ctx.getNode());
		   if (state == this.reviewStateDraft) return true;
		},

		postActionRegeneratePDF: function(ac) {
		  var headerView = csiView.getView("ORHeader");
		  if(headerView) {
		      var node = ac.getNode();
		      if(ac.getNode().hasOwnProperty(this.PENDING_PDF_STATUS)) {
		          headerView.getContext().getNode()[this.PENDING_PDF_STATUS] = node[this.PENDING_PDF_STATUS];
		      }
		      else if(ac.getNode().hasOwnProperty(this.APPROVED_PDF_STATUS)) {
		          headerView.getContext().getNode()[this.APPROVED_PDF_STATUS] = node[this.APPROVED_PDF_STATUS];
		      }
		      headerView.refreshWidget();
		  }
		},

		postActionSubQuestions: function(ac) {
			var propertyView = ac.widget.getSiblingView("Properties");
			if (propertyView) {
				propertyView.redraw();
			}
		},

		getReviewState: function(review) {
			return review && xml.enumGetText(review.State);
		}
	};
});
